export type DatepickerMode = 'date' | 'year'

/**
 * TODO: should be take from vanillajs-datepicker types after it is released
 */
export type DatepickerOptions = {
  daysOfWeekDisabled?: number[]
  minDate?: string | number | Date | null
  maxDate?: string | number | Date | null
  todayHighlight?: boolean
  pickLevel?: number
}
